import {TranslatableRental} from "./locations";
import {apt1Photos, mainPhotoApt1} from "./photo";
import {apt1FR} from "./descriptions/fr/apt1";
import {apt1EN} from "./descriptions/en/apt1";


export const apt1: TranslatableRental = {
  roomId: "501220",
  slugs: {
    fr: "appartement-deux-chambres-avec-terrasse-vue-sur-jardin",
    en: "apartment-two-bedrooms-with-terrace-and-garden-view"
  },
  name: {
    fr: "Appartement deux chambres avec vue sur jardin",
    en: "Two-bedroom apartment with garden view",
  },
  description: {
    fr: apt1FR,
    en: apt1EN
  },
  lodgifyId: "435085",
  area: 60,
  capacity: 4,
  numberOfBeds: 2,
  numberOfBedrooms: 2,
  numberOfBathrooms: 2,
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "coffee-machine",
    "fridge",
    "heater",
    "kitchen-storage",
    "swimming",
    "toilet",
    "shower",
    "wheelchair-way",
    "parking",
    "washing-machine",
    "microwave",
    "no-smoking",
    "iron",
    "kettle",
    "hair-dryer",
    "household-linen",
    "toaster"
  ],
  mainImage: mainPhotoApt1,
  assets: apt1Photos
};
